import { render, staticRenderFns } from "./DetailAdjustmentSostam.vue?vue&type=template&id=601f04b2"
import script from "./DetailAdjustmentSostam.vue?vue&type=script&lang=js"
export * from "./DetailAdjustmentSostam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports